/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import React from "react";

/* cSpell:disable */
export const EventAdditionalSection: React.FC = () => {
  return (
    <div id="act_info" css={containerStyle}>
      <div id="artists-title">
        <h2>ACT</h2>
      </div>

      <p id="artists-groups">
        【DAY1】
        <br />
        ーVALORANTー
        <br />
        ぶいすぽっ！チーム：紡木こかげ、花芽なずな、紫宮るな、小森めと、夜乃くろむ
        <br />
        コーチ：crow、Laz
        <br />
        ライバルチーム：ade、らっしゃー、RobiN、MeLton、ありけん
        <br />
        <br />
        ーLeague of Legendsー
        <br />
        ぶいすぽっ！チーム：橘ひなの、銀城サイネ、猫汰つな、白波らむね、花芽すみれ
        <br />
        コーチ：たぬき忍者、たかやスペシャル
        <br />
        ライバルチーム：まざー3、ゆふな、Kamito、SHAKA、なぎさっち
        <br />
        <br />
        ーSTREET FIGHTER 6ー
        <br />
        ぶいすぽっ！チーム：如月れん、藍沢エマ、蝶屋はなび
        <br />
        コーチ：KEI.B、ナウマン、あきら
        <br />
        ライバルチーム：へしこ、ズズ、ふらんしすこ
        <br />
        <br />
        <br />
        【DAY2】
        <br />
        ーVALORANTー
        <br />
        ぶいすぽっ！チーム：英リサ、一ノ瀬うるは、兎咲ミミ、八雲べに、夢野あかり
        <br />
        コーチ：GON、TORANECO
        <br />
        ライバルチーム：善悪菌、SurugaMonkey、ボドカ、SqLA、葉
        <br />
        <br />
        ーLeague of Legendsー
        <br />
        ぶいすぽっ！チーム：胡桃のあ、千燈ゆうひ、空澄セナ、龍巻ちせ、小雀とと
        <br />
        コーチ：しゃるる、yutapon
        <br />
        ライバルチーム：ザクレイ、Rainbrain、k4sen、Zerost、おぼ
        <br />
        <br />
        ーSTREET FIGHTER 6ー
        <br />
        ぶいすぽっ！チーム：神成きゅぴ、甘結もか
        <br />
        コーチ：なるお、ボンちゃん
        <br />
        ライバルチーム：宇野昌磨、高木
      </p>

      <div id="artists-grid">
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/PqkETkIz6687RdYzyw5C/bd907e05-6ab4-4f90-8b84-c4e548e69c4b"
              alt="紡木こかげ"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>紡木こかげ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/VVM3256kOL0EV6HmJ3rY/88b2f997-caff-45f0-b2ba-486b39368990"
              alt="花芽なずな"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>花芽なずな</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/9GfjCkBd65YI2AB4n1eY/0b3683ff-4fd4-4ae1-aeb5-bb5352ee303e"
              alt="紫宮るな"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>紫宮るな</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/HDMYcUjRtTWHA13vJef2/3579ab0d-1175-41c7-bd10-9e768f4ad233"
              alt="小森めと"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>小森めと</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/Jr6W4BDzsLKzgTNjqd0j/fbd30d60-2b47-4ff1-b908-9e305da9f0b5"
              alt="夜乃くろむ"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>夜乃くろむ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/UYFW2Vyi5NLeT3gmFOps/74294c8c-8dbf-468a-947f-499406c0cbd1_2_550x550"
              alt="crow"
            />
            <p>COACH</p>
          </div>
          <div>
            <h3>crow</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/yYREe3nRM2wvhigyxD99/94f0dae0-cec0-43d4-aed8-eabe20c712d4_2_550x550"
              alt="Laz"
            />
            <p>COACH</p>
          </div>
          <div>
            <h3>Laz</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/9bCxwhk3B4p147G7nDO8/3266c1c7-dc9b-4da5-b1e9-ed866cf09f06_2_550x550"
              alt="ade"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>ade</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/sK1NYqbnOyxYrUdnajCH/64e58672-4d85-4739-9bd1-8ee32d97cf6d_2_550x550"
              alt="らっしゃー"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>らっしゃー</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/nzvxIqVKDFTkO6pLNHsE/8c761676-f7ca-49d2-848f-0c8ba0ed5136_2_550x550"
              alt="RobiN"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>RobiN</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/dCMb6MhimdM8QcQNc2pz/d40eb9ee-71c8-4616-a7b5-dd014cd42a31_2_550x550"
              alt="MeLton"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>MeLton</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/c3jh8nn7v1LV6XfoLu1X/408e5621-58d8-4727-af92-63e6578cca30_2_550x550"
              alt="ありけん"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>ありけん</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/1o8i7vhzPmzevq3jo9Gn/4c25c338-76b7-4554-b25f-75d2e1dcf1ac"
              alt="橘ひなの"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>橘ひなの</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/DR3al2G7wwSVIIGQIwjy/c8f6c843-1900-4ebb-8220-b6c0970d833e"
              alt="銀城サイネ"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>銀城サイネ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/Pw2xUr2SmqkP5JVlDL3l/117ff17b-bc38-4189-b3a6-73cc482da42a"
              alt="猫汰つな"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>猫汰つな</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/bzAJQs3tK5iSPsbtRmUu/3f82e821-2188-4bcc-8a3c-a3b05d2e2e42"
              alt="白波らむね"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>白波らむね</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/R5ipsFisUKow2V8hiXQG/883dffc8-14c6-4994-ac83-179ce694775e"
              alt="花芽すみれ"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>花芽すみれ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/7x8ccBpbT4CVKEHrHO6P/9cb1a0f4-5210-41d4-9c49-118d92a90671_2_550x550"
              alt="たぬき忍者"
            />
            <p>COACH</p>
          </div>
          <div>
            <h3>たぬき忍者</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/PApoFuZeZNlaqpegFCq7/8a485d94-f166-45a4-aa92-46f47eae6b25_2_550x550"
              alt="たかやスペシャル"
            />
            <p>COACH</p>
          </div>
          <div>
            <h3>たかやスペシャル</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/Dx4VVZEWQgNIVUM3CkDo/5c047e1d-045e-4e59-b761-cad96ae25c95_2_550x550"
              alt="まざー3"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>まざー3</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/SHK2jXsWoNFdYEQ78ROD/26172281-5f02-4152-9ea4-b7beb868bdc7_2_550x550"
              alt="ゆふな"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>ゆふな</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/XAoxS65En4XZisMEuvxo/5c89666d-b43a-4844-bffe-0212e2147115_2_550x550"
              alt="Kamito"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>Kamito</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/YEUVhmCJ5eVpoN0rgPJ2/31deb7a6-fe62-493e-af59-10c94a6eb4dc_2_550x550"
              alt="SHAKA"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>SHAKA</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/gnwrs3gawARjNHZG2tj0/b1d5ea3d-0acf-46ec-a5c2-c98a1d0bc23b_2_550x550"
              alt="なぎさっち"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>なぎさっち</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/Fgbu1oia6orycmbOW3AT/91db4de8-739d-41a5-a225-f9a246257247"
              alt="如月れん"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>如月れん</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/XSjLfVPbcdISG35XFjGG/40a6fba2-e7f2-4f81-b233-33b4adcca691"
              alt="藍沢エマ"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>藍沢エマ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/b1sG5ukooZ9J8BRjetDb/4b062ef7-66a3-4cfb-bfcf-bb4e6b42a653"
              alt="蝶屋はなび"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>蝶屋はなび</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/Zfxsr0qcxirBbQAZsKk8/bc022d8a-2b9a-4c0d-aeaa-27c71ab23f78_2_550x550"
              alt="KEI.B"
            />
            <p>COACH</p>
          </div>
          <div>
            <h3>KEI.B</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/TeZvroRoiSV4JaXuRIJH/91b46c75-e66c-4bcd-b58c-f5a256103660_2_550x550"
              alt="ナウマン"
            />
            <p>COACH</p>
          </div>
          <div>
            <h3>ナウマン</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/Z1yS9PeZO4coAMFgPg2L/5268837c-07cc-4ae7-89b7-3821a9af904d_2_550x550"
              alt="あきら"
            />
            <p>COACH</p>
          </div>
          <div>
            <h3>あきら</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/uE0hn84RNgWQssqZUcLT/243bba12-2197-4867-bb20-b8d02ddee898_2_550x550"
              alt="へしこ"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>へしこ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/afCkxLppJKroD6ACW8hy/acc83238-f5d5-4b8c-832a-a4f4f8926515_2_550x550"
              alt="ズズ"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>ズズ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/CFAUViBNQ6qyVjeTUJVC/c7f6d54a-4cec-4ad9-9130-c1929a11bd10_2_550x550"
              alt="ふらんしすこ"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>ふらんしすこ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/lyMhtiiTCDkhaUf6jBms/02b47b83-7db4-43fe-b418-778decfa4fd1"
              alt="英リサ"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>英リサ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/opI1NWLtOThdC1NATOqi/64619edf-8329-4433-a043-ede72b850861"
              alt="一ノ瀬うるは"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>一ノ瀬うるは</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/TupAdgIZ3085iJ6qz9WZ/5e59b9ad-c9cb-400e-b432-b886d03082f4"
              alt="兎咲ミミ"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>兎咲ミミ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/lQwh4rzBaTE7ltYRDrkB/fc4a62a0-b2d8-4018-b03a-5d016c20cc6d"
              alt="八雲べに"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>八雲べに</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/cMhapJGdSq1NJkZgU6eM/830f8629-85ba-4c3e-a098-7be5e643c791"
              alt="夢野あかり"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>夢野あかり</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/RAHuTWIk2vYBpORbf6KU/98567055-14cd-44c5-a327-5e3692a49cf4_3_550x550"
              alt="GON"
            />
            <p>COACH</p>
          </div>
          <div>
            <h3>GON</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/zoFsQghP4D7LUvsQs6jF/9e5e1074-ae29-4c4b-a2d6-f5f12ee94729_2_550x550"
              alt="TORANECO"
            />
            <p>COACH</p>
          </div>
          <div>
            <h3>TORANECO</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/RK7yLilhF8dQApFwC8fk/de49acc6-84ec-495e-aec9-6f1b60bdd3f6_2_550x550"
              alt="善悪菌"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>善悪菌</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/epTriWQhcdsjRBCa0Eeb/75d253aa-6a9b-4912-b9c1-aae94937bf93_2_550x550"
              alt="SurugaMonkey"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>SurugaMonkey</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/JWDrrJmCjSxq1j6XGHAE/d7dc02da-0522-4313-8178-4e72fe462db9_2_550x550"
              alt="ボドカ"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>ボドカ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/8YksO3l4Vbb27pkRXqlo/bf4094fc-ff46-4d8e-b820-13991648eff6_2_550x550"
              alt="SqLA"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>SqLA</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/BGU6cyaj7qjsxKnLOfKK/1e101d7a-3a7a-453c-a031-98a6485a0509_2_550x550"
              alt="葉"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>葉</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/XYqDaeUL1uQQXvoeUurG/bd7c306a-2fe1-4a2c-ad87-0531ebacdb38"
              alt="胡桃のあ"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>胡桃のあ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/hcUV6bxlh6BFofBn4URu/44681a36-e405-4663-8eda-a027c71f46cc"
              alt="千燈ゆうひ"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>千燈ゆうひ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/XWpFGXjNDnIT1fgUY2s5/b2139c45-d765-4759-a863-e1081d30606c"
              alt="空澄セナ"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>空澄セナ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/cSInJizzkWQmnvjDSRSk/47d1eb4b-e006-4c89-9185-9bc18b1dd381"
              alt="龍巻ちせ"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>龍巻ちせ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/r8wXmu8JHlWllzKV5WVj/f18b3b1e-dffa-46c6-bbde-f20a50a2aa05"
              alt="小雀とと"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>小雀とと</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/33u5rAxGF5El6QDM9f3L/88ebfcfa-9a45-4fcd-9102-dcdd8311b0aa_2_550x550"
              alt="しゃるる"
            />
            <p>COACH</p>
          </div>
          <div>
            <h3>しゃるる</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/og6PFh7iCWKUgQG6WfpT/68b8f4bc-cdd9-48a1-8102-99f8aee549fe_2_550x550"
              alt="yutapon"
            />
            <p>COACH</p>
          </div>
          <div>
            <h3>yutapon</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/yPllNzR2MuMXfSnJEtrr/f56ffd04-e061-4952-90de-de44d1b38134_2_550x550"
              alt="ザクレイ"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>ザクレイ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/t5xIrclJzXS93cFyC9EX/9412005e-faa4-48a2-bf0a-403c729fbda2_4_550x550"
              alt="Rainbrain"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>Rainbrain</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/YjKvLBCcHI2SIwsJs59b/15677bf8-6249-4085-9b4b-d2085c40f2d2_2_550x550"
              alt="k4sen"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>k4sen</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/ZJQ870t1SEinyHGcJLUd/a79ab327-f597-4b47-8745-a46ecb50fca6_2_550x550"
              alt="Zerost"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>Zerost</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/Wu0Cvcl2s0AzAHqs0xXs/b711fe97-10c0-4fe1-8bae-3cf9e5858b39_3_550x550"
              alt="おぼ"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>おぼ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/x8rtHdPyhC9iSbsDLDsO/fb8e619d-f2b6-479a-962d-36c127cc7bac"
              alt="神成きゅぴ"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>神成きゅぴ</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/ZRKJBZwdDGbtonDSQzHy/8973b388-89cf-494f-9178-393222b63ff6"
              alt="甘結もか"
            />
            <p>VSPO!</p>
          </div>
          <div>
            <h3>甘結もか</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/6sWfDvNWCdMuWnp2TUyK/ad26aeee-335a-4211-b026-b035e0fe97a6_2_550x550"
              alt="なるお"
            />
            <p>COACH</p>
          </div>
          <div>
            <h3>なるお</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/yZRFRaLoFrrXQ9i7TIjE/245e3518-7954-4da0-9f73-f0fa1aef49f9_2_550x550"
              alt="ボンちゃん"
            />
            <p>COACH</p>
          </div>
          <div>
            <h3>ボンちゃん</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/L74IIusHWbXEgvoHpbh3/86076339-a10e-4723-a229-e96e4c17d54b_2_550x550"
              alt="宇野昌磨"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>宇野昌磨</h3>
          </div>
        </article>
        <article>
          <div>
            <img
              src="https://public-web.spwn.jp/artists/AEAh0eHtgusm5nayLO3k/189f707c-4da2-44a2-afb2-be21658fb568_2_550x550"
              alt="高木"
            />
            <p>RIVAL</p>
          </div>
          <div>
            <h3>高木</h3>
          </div>
        </article>
      </div>
    </div>
  );
};

const containerStyle = css`
  #artists-grid {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 48px;
    max-width: 980px;
    margin-left: auto;
    margin-right: auto;
    color: #fff;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  }
  #artists-grid *,
  #artists-grid *::before,
  #artists-grid *::after {
    box-sizing: inherit;
  }
  #artists-grid::before,
  #artists-grid::after {
    content: none;
  }
  #artists-title {
    margin-top: 48px;
    width: 100%;
    letter-spacing: 1px;
  }
  #artists-title > h2 {
    margin: 0 0 5px;
    padding: 5px 0 0 15px;
    border-left: 5px solid #00c2ae;
    font-family: "din-condensed", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 35px;
    line-height: 1;
    color: #000;
  }
  #artists-title > p {
    margin: 0;
    padding-left: 21px;
    font-size: 12px;
    line-height: 1.3;
    color: #000;
  }
  #artists-groups {
    margin-top: 24px;
    font-weight: bold;
    line-height: 1.8;
    color: #000;
  }
  #artists-grid > article {
    position: relative;
    width: 47.5%;
    margin-bottom: 40px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    color: #000;
    overflow: visible;
  }
  #artists-grid > article > div:first-of-type {
    position: relative;
  }
  #artists-grid > article > div:first-of-type > img {
    display: block;
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    object-position: 50% 0%;
    border-radius: 5px 5px 0 0;
  }
  #artists-grid > article > div:first-of-type > p {
    position: absolute;
    top: -20px;
    left: -8px;
    width: 65px;
    height: 42px;
    margin: 0;
    padding-top: 9px;
    font-family: "din-condensed", sans-serif;
    font-weight: 400;
    font-style: normal;
    color: #01ffe1;
    font-size: 16px;
    text-align: center;
    background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNjRweCIgaGVpZ2h0PSI0MHB4IiB2aWV3Qm94PSIwIDAgNjQgNDAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT4wNF9hdG9tL2xhYmVsL2FjdDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPgogICAgICAgIDxwb2x5Z29uIGlkPSJwYXRoLTEiIHBvaW50cz0iMCAwIDggOCA4IDAiPjwvcG9seWdvbj4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSIwNF9hdG9tL2xhYmVsL2FjdCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAuNSwwLjUgTDAuNSwzMS41IEw1MS4xOTgwNTAyLDMxLjUgTDYzLjUsMTguODg5NzAzOSBMNjMuNSwwLjUgTDAuNSwwLjUgWiIgaWQ9ImJnIiBzdHJva2U9IiMwMEZGRTUiIGZpbGw9IiMxMzE4MTkiPjwvcGF0aD4KICAgICAgICA8ZyBpZD0iUmVjdGFuZ2xlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMzIuMDAwMDAwKSI+CiAgICAgICAgICAgIDxtYXNrIGlkPSJtYXNrLTIiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+CiAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgPHVzZSBpZD0iTWFzayIgZmlsbD0iIzI5MzQzQSIgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+CiAgICAgICAgICAgIDxyZWN0IGZpbGw9IiMwRjVENjAiIG1hc2s9InVybCgjbWFzay0yKSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC41OTYxOTQsIDMuODUzNTUzKSByb3RhdGUoLTQ1LjAwMDAwMCkgdHJhbnNsYXRlKC00LjU5NjE5NCwgLTMuODUzNTUzKSAiIHg9IjQuMDk2MTk0MDgiIHk9Ii0yLjE0NjQ0NjYxIiB3aWR0aD0iMSIgaGVpZ2h0PSIxMiI+PC9yZWN0PgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    line-height: 1;
    z-index: 1;
    pointer-events: none;
  }
  #artists-grid > article > div:nth-of-type(2) {
    padding: 16px;
  }
  #artists-grid > article > div:nth-of-type(2) > h3 {
    margin: 0;
    font-size: 15px;
    text-align: center;
    line-height: 1.4em;
    white-space: pre-line;
    font-weight: 700;
  }
  #artists-grid > article > p:last-of-type {
    position: absolute;
    bottom: 10px;
    right: 7%;
    margin: 0;
    color: rgba(0, 194, 174, 0.25);
    font-weight: bold;
    font-size: 20px;
    line-height: 1;
  }
  @media screen and (min-width: 768px) {
    #artists-title {
      display: flex;
      align-items: center;
    }
    #artists-title > h2 {
      margin-bottom: 0;
      letter-spacing: 3px;
    }
    #artists-title > p {
      font-size: 16px;
    }
    #artists-grid::before {
      content: "";
      display: block;
      width: 24%;
      order: 1;
    }
    #artists-grid::after {
      content: "";
      display: block;
      width: 24%;
    }
    #artists-grid > article {
      width: 24%;
      margin-bottom: 60px;
    }
    #artists-grid > article > div:first-of-type > p {
      width: 100px;
      height: 48px;
      padding-top: 12px;
      font-size: 20px;
      background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTIwcHgiIGhlaWdodD0iNDhweCIgdmlld0JveD0iMCAwIDEyMCA0OCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTUuMiAoNzgxODEpIC0gaHR0cHM6Ly9za2V0Y2hhcHAuY29tIC0tPgogICAgPHRpdGxlPjA0X2F0b20vbGFiZWwvYWN0X3BjPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IjA0X2F0b20vbGFiZWwvYWN0X3BjIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iMDQvYXRvbS9sYWJlbC9ncm4iPgogICAgICAgICAgICA8cGF0aCBkPSJNMSwxIEwxLDM5IEwxMDkuNTg1Nzg2LDM5IEwxMTksMjkuNTg1Nzg2NCBMMTE5LDEgTDEsMSBaIiBpZD0iYmciIHN0cm9rZT0iIzAwRkZFNSIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsPSIjMTMxODE5Ij48L3BhdGg+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjIwNzEwNjc4LDQwLjUgTDcuNSw0Ni43OTI4OTMyIEw3LjUsNDAuNSBMMS4yMDcxMDY3OCw0MC41IFoiIGlkPSJGaWxsLTEiIHN0cm9rZT0iIzBGNUQ2MCIgZmlsbD0iIzI5MzQzQSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+");
    }
    #artists-grid > article > div:nth-of-type(2) > h3 {
      font-size: 20px;
    }
    #artists-grid > article > p:last-of-type {
      right: 20px;
    }
  }
`;
